/**
 * Created by admin on 2017/12/4.
 */
import messagesEn from "./en.js";
import messagesCn from "./cn.js";

const messages = {
  en: messagesEn,
  cn: messagesCn
};
export default messages;



// WEBPACK FOOTER //
// ./src/lan/index.js